import React from 'react';

/**
 * Error icon SVG — replaces @atlaskit/icon ErrorIcon.
 *
 * @param {Object} props - Component props.
 * @param {string} props.label - Accessible label for the icon.
 * @returns {ReactElement}
 */
const ErrorIconSVG = ({ label }) => (
    <svg
        aria-label = { label }
        className = 'custom-title-icon__svg'
        fill = 'currentColor'
        height = '20'
        role = 'img'
        viewBox = '0 0 24 24'
        width = '20'
        xmlns = 'http://www.w3.org/2000/svg'>
        <title>{label}</title>
        <path d = 'M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 15a1 1 0 110-2 1 1 0 010 2zm1-4a1 1 0 01-2 0V8a1 1 0 012 0v5z' />
    </svg>
);

export default ErrorIconSVG;
